import Avatar from "./avatar";

export { type AvatarProps } from "./avatar";

export { Avatar };
